export class InvoiceAmortizationSchedule {
    invoiceID: number;
    invoiceAmortizationScheduleID: number;
    issued: boolean;
    issueAt: Date;
    dueDate: Date;
    amount: number;
}